import { VaulTokensProvider } from '@/contexts/VaultTokensContext'
import { AppShell } from '@/design-system/AppShell'
import VaultPage from '@/modules/components/Vault/VaultPage'

const Stake = () => {
  return <VaultPage />
}

Stake.getLayout = function getLayout(page) {
  return (
    <VaulTokensProvider>
      <AppShell>{page}</AppShell>
    </VaulTokensProvider>
  )
}

export default Stake
